module.exports = __webpack_public_path__ + "static/img/1067_small.444bc69.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1067_small.png
// module id = e8Z1
// module chunks = 1